import React, { createContext } from 'react';
import { node } from 'prop-types';

import { useReservationUpdateApi } from '../hooks/useReservationUpdateApi';

export const defaultContext = {
  data: null,
  loading: false,
  error: '',
  executeRequest: async () => {}
};

export const ReservationUpdateApiContext = createContext(defaultContext);

const ReservationUpdateApiProvider = ({ children }) => {

  return (
    <ReservationUpdateApiContext.Provider
      value={{ ...useReservationUpdateApi() }}
    >
      {children}
    </ReservationUpdateApiContext.Provider>
  );
};

ReservationUpdateApiProvider.propTypes = {
  children: node.isRequired
};

export default ReservationUpdateApiProvider;
